import httpService from './httpService';
import {
    DeviceDetailResponse,
    DeviceListResponse,
    DeviceListRequest,
    MultiDeassociateRequest,
    RefreshDevicesRequest,
    refreshDevicesResponse,
    HandleGetProductOptionsData,
    HandleGetProductOptionsResponse,
} from '../types/pages/device';
import { APIResponse } from '@/types';

const getInitiator = (): string => `webpage|${window.location.href}`;

export function getDeviceDetail(mac: string): APIResponse<DeviceDetailResponse> {
    return httpService.get(`/device/${mac}`);
}

export function fetchDeviceList(
    corporationId: number,
    requestParams: DeviceListRequest,
    options?: { signal?: AbortSignal },
): APIResponse<DeviceListResponse> {
    return httpService.get(`/devices/list/${corporationId}`, {
        params: requestParams,
        signal: options?.signal,
    });
}

export const deassociateMultipleDevices = async (macAddresses: string[]): Promise<APIResponse<null>> => {
    try {
        const payload: MultiDeassociateRequest & { m2c_initiator: string } = {
            job_type: 'task',
            command: 'deassociate',
            devices: macAddresses,
            m2c_initiator: getInitiator(),
        };

        const response = await httpService.put<APIResponse<null>>(`/devices/command`, payload);

        return response.data;
    } catch (error) {
        console.error('Error deassociating multiple devices:', error);
        throw error;
    }
};

export const refreshDevicesAPI = async (data: RefreshDevicesRequest): APIResponse<refreshDevicesResponse> => {
    return httpService.put('/devices/command', {
        ...data,
        m2c_initiator: getInitiator(),
    });
};

export const handleGetProductOptionsAPI = async (
    cid: number,
    data: HandleGetProductOptionsData,
): APIResponse<HandleGetProductOptionsResponse> => {
    return httpService.post(`/products/search/${cid}`, data);
};
